module.exports = __webpack_public_path__ + "assets/img/CGTN.5d440001.jpg";